export function createAutomationListTrigger(data={}) {
    return Object.freeze(new AutomationListTrigger(data));
}

export class AutomationListScheduledTrigger {
    constructor({
                    //attributes
                    automation_list_id= null,
                    automation_list_trigger_id= null,
                    trigger_at= null,
                    created_at= new Date(),
                    updated_at= new Date(),
                } = {}) {

        //fill attributes
        this.automation_list_id=automation_list_id;
        this.automation_list_trigger_id=automation_list_trigger_id;
        this.trigger_at=trigger_at;
        this.created_at=created_at;
    }

    set local_trigger_at(val){
        this.trigger_at = moment(val).utc()
    }

    get local_trigger_at(){
        let localTime = moment.utc(this.trigger_at).local()
        return localTime.format('L') + " " + localTime.format('LT');
    }
}
